import React from 'react';
import MonestLoader from '../monest-loader';

import './importer-loader.scss';

const ImporterLoader = ({ active = false }) => {

    if (!active) {
        return null;
    }

    return (
        <div className="ImporterLoader">
            <h1>
                Estamos processando sua planilha.<br />
                Só mais um pouco e já podemos continuar :)
            </h1>
            <div className="loader">
                <MonestLoader size={5} />
            </div>
        </div>
    );

};

export default ImporterLoader;
